import React from "react";
import { Helmet } from "react-helmet";
import Loader from "../../../components/common/Loader";
import Footer from "../../../components/home1/Footer";
import Menu from "../../../components/innerpage/Menu";
import Navbar from "../../../components/home1/Navbar";
import ServiceDetail from "../../../components/innerpage/service_detail/ServiceDetail";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../../seoConfig";

const PAGE_TITLE = "Architecture & Exterior Design Services | " + SITE_NAME;
const PAGE_DESC =
  "Expert architectural planning, site design, and exterior facade design for residential, commercial, and hospitality projects. From concept to construction drawings and 3D visualization.";
const PAGE_PATH = "/innerpages/services/architecture-exterior-design";

function ArchitectureExteriorDesign() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESC} />
        <meta
          name="keywords"
          content="architecture design, exterior design, facade design, architectural planning, site planning, 3D elevation, villa architecture, commercial architecture"
        />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESC} />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />
        <meta property="og:site_name" content={SITE_NAME} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESC} />
        <meta name="twitter:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />

        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
        <body className="inner-pages-style1 s-project-pg-style1 service-detail-page" />
      </Helmet>
      <Loader />
      <Menu />
      <div className="smooth-scroll-content" id="scrollsmoother-container">
        <Navbar />
        <main>
          <ServiceDetail
            tag="Architecture"
            title="Architecture & Exterior Design"
            intro="Architecture is the foundation of every exceptional space, built on a perfect balance of creativity, functionality, and technical precision."
            heroImage="/innerpages/assets/img/services/1.webp"
            // TODO: swap these 4 paths for your actual image files
            gallery={[
              "/innerpages/assets/img/services/gallery/architecture-1.jpg",
              "/innerpages/assets/img/services/gallery/architecture-2.jpg",
              "/innerpages/assets/img/services/gallery/architecture-3.jpg",
              "/innerpages/assets/img/services/gallery/architecture-4.jpg",
              "/innerpages/assets/img/services/gallery/architecture-5.jpg",
            ]}
            paragraphs={[
              "At our studio, we believe that great design is a perfect balance of creativity, functionality, and technical precision. Every project begins with understanding your vision, lifestyle, business goals, and the unique characteristics of the site. This allows us to create designs that are not only visually striking but also practical, efficient, and built to last.",
              "Our architectural process covers every stage, from concept development and site planning to detailed construction drawings and 3D visualizations. We pay close attention to circulation, natural lighting, ventilation, structural efficiency, and sustainability to ensure every space performs beautifully in everyday use.",
              "The exterior of a building is its identity. Through carefully crafted facades, premium material selection, architectural detailing, landscape integration, and lighting design, we create exteriors that leave a lasting impression while complementing their surroundings. Whether it's a contemporary villa, luxury residence, commercial building, office, retail space, or hospitality project, every design is tailored to reflect its purpose and personality.",
              "Our collaborative approach ensures that clients remain involved throughout the design journey. We transform ideas into architectural experiences that combine timeless aesthetics with long-term value.",
            ]}
            listTitle="Our Architecture & Exterior Design Services"
            listItems={[
              "Architectural Planning & Concept Development",
              "Residential & Commercial Architecture",
              "Site Planning & Space Optimization",
              "2D Floor Plans & Working Drawings",
              "3D Elevation & Exterior Visualization",
              "Facade Design & Development",
              "Landscape Integration",
              "Material & Finish Selection",
              "Renovation & Exterior Transformation",
              "Design Consultation & Technical Support",
            ]}
            otherServices={[
              {
                title: "Interior Design",
                link: "/innerpages/services/interior-design",
              },
              {
                title: "Furniture Design",
                link: "/innerpages/services/furniture-design",
              },
              {
                title: "Project Consultation",
                link: "/innerpages/services/project-consultation",
              },
            ]}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default ArchitectureExteriorDesign;
